/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent } from 'react';
import { Logo } from '@doveit/lego';
import Link from 'next/link';
import * as styles from './AdvInterstitial.style';
import {
  buildAgenciesURLObject, buildEvaluationURLObject, buildSellPropertyGuideURLObject, URLObject,
} from '../../utils/links';
import * as graphCMS from '../../../domain/graphcms';

export interface AdvInterstitialProps {
  dataRef?: string,
  guideRef?: Pick<graphCMS.Guide, 'id' | 'title' | 'alternateTitle'>,
  currentGuideId?: graphCMS.Guide['id'],
}

function buildLink(urlObject: URLObject, label: string) {
  return (
    <Link
      href={urlObject.url}
      as={urlObject.as}
    >
      {label}
    </Link>
  );
}

const AdvInterstitial: FunctionComponent<AdvInterstitialProps> = ({
  dataRef = 'adv-interstitial',
  currentGuideId,
  guideRef,
}) => {
  const howToSellHouseOnlineFragment = React.useMemo(() => {
    if (!guideRef || (currentGuideId && currentGuideId === guideRef.id)) {
      return 'vendere casa online';
    }

    return buildLink(buildSellPropertyGuideURLObject(guideRef), 'vendere casa online');
  }, [currentGuideId, guideRef]);

  return (
    <div
      data-ref={dataRef}
      css={styles.base}
    >
      <div css={styles.logo}>
        <Logo />
      </div>
      <div>
        <strong>Dove.it</strong> è un&apos;agenzia immobiliare online che si affida alla tecnologia e ai migliori agenti sul territorio per garantire
        ai propri clienti una corretta {buildLink(buildEvaluationURLObject(), 'valutazione immobile')} e per {howToSellHouseOnlineFragment} al <strong>miglior prezzo</strong> e nel minor tempo possibile. Semplificando i processi è in grado di offrire un servizio
        a <strong>ZERO commissioni</strong> per chi vende mantenendo al centro della sua offerta la relazione umana tra clienti e agenti tramite le sue {buildLink(buildAgenciesURLObject(), 'agenzie immobiliari')} sul territorio.
      </div>
    </div>
  );
};

export default AdvInterstitial;
